import React, { useState, useEffect, useRef } from "react";

import { Collapse, InputNumber, Select, Skeleton } from "antd";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const { Panel } = Collapse;
const { Option } = Select;

const NotasTurmaDestino = ({ turma, setDisciplinasDestino, semAlertas, semTag }) => {
    const [disciplinas, setDisciplinas] = useState([]);
    const [editingNota, setEditingNota] = useState(null);
    const inputRef = useRef(null);
    const selectRef = useRef();

    const handleNotaChange = (disciplinaIndex, avaliacaoId, value) => {
        const novasDisciplinas = [...disciplinas];
        const avaliacaoIndex = novasDisciplinas[disciplinaIndex].avaliacoes.findIndex(a => a.id === avaliacaoId);

        if (avaliacaoIndex !== -1) {
            novasDisciplinas[disciplinaIndex].avaliacoes[avaliacaoIndex].nota.nota_numero = value;
            setDisciplinas(novasDisciplinas);
        }
    };

    const handleNotaSelectChange = (disciplinaIndex, avaliacaoId, value) => {
        const novasDisciplinas = [...disciplinas];
        const avaliacaoIndex = novasDisciplinas[disciplinaIndex].avaliacoes.findIndex(a => a.id === avaliacaoId);

        if (avaliacaoIndex !== -1) {
            novasDisciplinas[disciplinaIndex].avaliacoes[avaliacaoIndex].nota.nota_texto = value;
            setDisciplinas(novasDisciplinas);
        }
    };

    const salvarNota = avaliacaoId => {
        setEditingNota(null);
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        if (selectRef.current) {
            selectRef.current.focus(); // foca o componente
            //selectRef.current.rcSelect?.setOpen?.(true); // abre o dropdown
        }
    }, [editingNota]);

    useEffect(() => {
        const disciplinasFormatadas = disciplinas?.map(disciplina => {
            const avaliacoes = disciplina.avaliacoes.map(avaliacao => {
                return {
                    id: avaliacao.id,
                    nota: {
                        nota_numero: avaliacao.nota?.nota_numero,
                        nota_texto: avaliacao.nota?.nota_texto
                    }
                };
            });

            return {
                id: disciplina.id,
                avaliacoes: avaliacoes
            };
        });
        setDisciplinasDestino(disciplinasFormatadas);
    }, [disciplinas]);

    useEffect(() => {
        if (turma?.disciplinas) setDisciplinas(turma?.disciplinas);
    }, [turma]);

    return (
        <div className="bloco">
            <div>
                <div>{turma?.escola}</div>
                <div style={{ fontSize: 20, marginBottom: 40 }}>
                    {turma?.nome} {!semTag && "(Destino)"}
                </div>
            </div>
            <div>
                {disciplinas?.length === 0 && (
                    <div className="skeleton-loading">
                        {Array.from({ length: 10 }).map((_, index) => (
                            <Skeleton key={index} paragraph={false} title={{ width: 300 }} active />
                        ))}
                    </div>
                )}
                {disciplinas?.length > 0 && (
                    <Collapse accordion defaultActiveKey={[]} className="collapse-diario-observacoes">
                        {disciplinas?.map((disciplina, disciplinaIndex) => (
                            <Panel
                                header={
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
                                        <span style={{ width: "80%" }}>{disciplina.nome}</span>
                                        {!semAlertas &&
                                            (disciplina.importacaoTotal ? (
                                                <FaCheckCircle style={{ fontSize: 20, color: "green" }} />
                                            ) : (
                                                <FaExclamationTriangle style={{ fontSize: 20, color: "orange" }} />
                                            ))}
                                    </div>
                                }
                                key={disciplinaIndex}
                            >
                                {disciplina.periodos?.map(periodo => (
                                    <div
                                        key={periodo.id}
                                        style={{
                                            paddingBottom: 20,
                                            marginBottom: 20,
                                            borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
                                            marginRight: 5
                                        }}
                                    >
                                        <label style={{ fontSize: "16px" }}>{periodo.titulo}</label>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 20 }}>
                                            {disciplina.avaliacoes
                                                ?.filter(a => a.id_periodo === periodo.id)
                                                .map(avaliacao => {
                                                    const avaliacaoKey = avaliacao.id;
                                                    const isEditing = editingNota === avaliacaoKey;
                                                    const isNotas = disciplina.tipoNotas;
                                                    const valorNota = isNotas ? avaliacao.nota?.nota_numero : avaliacao.nota?.nota_texto;

                                                    return (
                                                        <div
                                                            key={avaliacao.id}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                gap: 10
                                                            }}
                                                        >
                                                            <span>{avaliacao.nome}</span>
                                                            {isEditing ? (
                                                                isNotas ? (
                                                                    <InputNumber
                                                                        ref={inputRef}
                                                                        value={valorNota || ""}
                                                                        onChange={value =>
                                                                            handleNotaChange(disciplinaIndex, avaliacaoKey, value)
                                                                        }
                                                                        onBlur={() => salvarNota(avaliacaoKey)}
                                                                        onPressEnter={() => salvarNota(avaliacaoKey)}
                                                                        className="nota-input"
                                                                    />
                                                                ) : (
                                                                    <Select
                                                                        defaultOpen={true}
                                                                        placeholder="Selecionar"
                                                                        ref={selectRef}
                                                                        value={valorNota || ""}
                                                                        onChange={value =>
                                                                            handleNotaSelectChange(disciplinaIndex, avaliacaoKey, value)
                                                                        }
                                                                        onBlur={() => salvarNota(avaliacaoKey)}
                                                                        className="nota-input-select"
                                                                    >
                                                                        {disciplina.opcoesAvaliacao.map((opcao, opcaoIndex) => (
                                                                            <Option key={opcaoIndex} value={opcao}>
                                                                                {opcao}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                )
                                                            ) : (
                                                                <span
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        border: "1px solid #d0d2d3",
                                                                        borderRadius: "4px",
                                                                        height: "30px",
                                                                        width: "100px",
                                                                        padding: "5px",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => setEditingNota(avaliacaoKey)}
                                                                >
                                                                    {valorNota}
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                ))}
                            </Panel>
                        ))}
                    </Collapse>
                )}
            </div>
        </div>
    );
};

export default NotasTurmaDestino;
